import { render, staticRenderFns } from "./importantKey.vue?vue&type=template&id=75bad193&scoped=true"
import script from "./importantKey.vue?vue&type=script&lang=js"
export * from "./importantKey.vue?vue&type=script&lang=js"
import style0 from "./importantKey.vue?vue&type=style&index=0&id=75bad193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bad193",
  null
  
)

export default component.exports